import { ContractFeeChargesShow } from '@Resources/contract_fee_charges/ContractFeeChargesShow';
import { ResourceDefinition } from '@Utils/types';

export const contractFeeChargesResource: ResourceDefinition = {
  options: { label: 'menu.contract_fee_charges' },
  show: ContractFeeChargesShow,
};
